import React, { useState } from 'react';
import api from '../lib/api';

export function resolveProfilePhoto(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  const photo = value.trim();
  if (/^(data:image\/|blob:|https?:\/\/)/i.test(photo)) return photo;
  if (photo.startsWith('/api/uploads/')) {
    return new URL(photo, new URL(api.defaults.baseURL, window.location.origin).origin).href;
  }
  return photo;
}

export default function ProfileImage({ src, fallback = 'U', className = 'w-full h-full object-cover' }) {
  const resolved = resolveProfilePhoto(src);
  const [failed, setFailed] = useState(null);
  if (!resolved || failed === resolved) return <span aria-label="Perfil" className="font-bold">{fallback}</span>;
  return <img key={resolved} src={resolved} alt="Perfil" className={className} onError={() => setFailed(resolved)} />;
}
